module.exports = __webpack_public_path__ + "static/media/heart2.de6a3656.svg";